import {EnvironmentParams} from './envirounmet.interface';

export const environment: EnvironmentParams = {
    production: true,
    sentry: {
        dsn: 'https://82e97ed834264b849178c4131fee558b@sentry.appodeal.com/4',
        options: {
            whitelistUrls: [/^https?:\/\/\S+.appodeal\.com\//],
            sanitizeKeys: ['password', 'currentPassword', 'confirmationCode', 'intercomSign'],
        },
    },
    intercomApp: 'kg4ccblk',
    userpilotTracking: '82ws92r8',
    mixpanelTracking: 'fb8903ea0d93aead25f77fd157c65c6e',
    facebookPixelId: '1468129376844388',
    graphQlEndpoint: '/graphql',
    admobSyncLink: 'https://wiki.appodeal.com/en/admob-sync',
    hubspotTrackingId: '5606823',
    enableHotJar: true,
};
